<template>
  <v-container fluid>
    <RangeFilter 
      :end="dateEnd" 
      :start="dateStart" 
      @getDates="getDates" 
      :excludePeriod="excludePeriod"
      :defaultPeriod="defaultPeriod"
      :setDates="true"
      :disabled="loaded"
    />
    <v-row>
      <v-col cols="12" xs="12" sm="3">
        <v-card class="pa-1" :loading="loaded" loader-height="2">
          <v-card-title>Avg. Cost per 1 gallon</v-card-title>
          <v-card-text class="text-card">${{ this.data.total_ppc_one_gallon | formatPrice }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>Avg. PPC cost per 1 gallon by day</h2>
        <v-progress-linear
          indeterminate
          color="indigo"
          v-if="loaded"
        ></v-progress-linear>
        <highcharts :options="chartOptionsDay"></highcharts>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>Avg. PPC cost per 1 gallon by week</h2>
        <v-progress-linear
          indeterminate
          color="indigo"
          v-if="loaded"
        ></v-progress-linear>
        <highcharts :options="chartOptionsWeek"></highcharts>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>Avg. PPC cost per 1 gallon by month</h2>
        <v-progress-linear
          indeterminate
          color="indigo"
          v-if="loaded"
        ></v-progress-linear>
        <highcharts :options="chartOptionsMonth"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'
import {Chart} from 'highcharts-vue'

export default {
  components: {
    RangeFilter,
    highcharts: Chart
  },
  data() {
    return {
      hideAnything: false,
      selected: [],
      data: [],
      historyChanged: [],
      userName: null,
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
                  Date.UTC(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      loaded: false,
      chartOptionsDay: {
        chart: {
          height: 700,
          type: 'areaspline',
          zoomType: 'x'
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
            formatter: function () {
                var tip = "<b>" + this.x + "</b>";
                tip += "<br/><span>"+ this.series.name + "</span>: " + '$'+ this.y.toFixed(2) + "<br/>";
                return tip;
            },
        },
        xAxis: {
          gridLineWidth: 1,
          minPadding: 0,
          maxPadding: 0,
          categories: [],
          crosshair: true,
          labels: {
            formatter: function() {
                return this.value;
            },
          },
          type: 'datetime',
          tickPositioner: function () {
            let positions = [],        
                tick = Math.floor(this.dataMin),
                increment = Math.ceil((this.dataMax - this.dataMin) / 10)
          
            if (this.dataMax === 0) {
              positions = [0]
            } else if (this.dataMax !== null && this.dataMin !== null) {
                for (tick; tick  <= this.dataMax; tick += increment) {
                  positions.push(tick)
                }
            }
            return positions
          }
        },
        yAxis: {
          crosshair: true,
          title: {
            text: 'Price'
          },
          labels: {
            formatter: function() {
                return (this.value > 0) ? `$${this.value}` : '0';
            },
          },
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.05,
            marker: {
              symbol: 'circle',
              radius: 3
            }
          }
        },
        series: [],
      },
      chartOptionsWeek: {
        chart: {
          height: 700,
          type: 'areaspline',
          zoomType: 'x',
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
            formatter: function () {
                var tip = "<b>" + this.x + "</b>";
                tip += "<br/><span>"+ this.series.name + "</span>: " + '$'+ this.y.toFixed(2) + "<br/>";
                return tip;
            },
        },
        xAxis: {
          gridLineWidth: 1,
          minPadding: 0,
          maxPadding: 0,
          categories: [],
          crosshair: true,
          labels: {
          },
          type: 'datetime',
          tickPositioner: function () {
            let positions = [],        
                tick = Math.floor(this.dataMin),
                increment = Math.ceil((this.dataMax - this.dataMin) / 10)
          
            if (this.dataMax === 0) {
              positions = [0]
            } else if (this.dataMax !== null && this.dataMin !== null) {
                for (tick; tick  <= this.dataMax; tick += increment) {
                  positions.push(tick)
                }
            }
            return positions
          }
        },
        yAxis: {
          crosshair: true,
          title: {
            text: 'Price'
          },
          labels: {
            formatter: function() {
                return (this.value > 0) ? `$${this.value}` : '0';
            }
          },
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.05,
            marker: {
              symbol: 'circle',
              radius: 3
            }
          }
        },
        series: [
        ],
      },
      chartOptionsMonth: {
        chart: {
          height: 500,
          type: 'areaspline',
          zoomType: 'x'
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
            formatter: function () {
                var tip = "<b>" + this.x + "</b>";
                tip += "<br/><span>"+ this.series.name + "</span>: " + '$'+ this.y.toFixed(2) + "<br/>";
                return tip;
            },
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
          labels: {
            formatter: function() {
                return this.value;
            }
          },
          type: 'datetime',
          tickPositioner: function () {
            let positions = [],        
                tick = Math.floor(this.dataMin),
                increment = Math.ceil((this.dataMax - this.dataMin) / 10)
          
            if (this.dataMax === 0) {
              positions = [0]
            } else if (this.dataMax !== null && this.dataMin !== null) {
                for (tick; tick  <= this.dataMax; tick += increment) {
                  positions.push(tick)
                }
            }
            return positions
          }
        },
        yAxis: {
          crosshair: true,
          min: 0,
          title: {
            text: 'Price'
          },
          labels: {
            formatter: function() {
                return (this.value > 0) ? `$${this.value}` : '0';
            }
          },
          endOnTick: true,
        },
        plotOptions: {
          areaspline: {
            pointStart: 0,
            fillOpacity: 0.05,
            marker: {
              symbol: 'circle',
              radius: 3
            }
          }
        },
        series: [],
      },
      chartOptionsRelevanceByDay: {
        chart: {
          height: 500,
          type: 'column',
          zoomType: 'x'
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
            formatter: function () {
                var tip = "<b>" + this.x + "</b>";
                tip += "<br/><span>"+ this.series.name + "</span>: " + this.y.toFixed(2) + "<br/>";
                return tip;
            },
        },
        xAxis: {
          categories: [],
          crosshair: true,
          labels: {
            formatter: function() {
                return this.value;
            }
          },
          type: 'datetime',
          tickPositioner: function () {
            let positions = [],        
                tick = Math.floor(this.dataMin),
                increment = Math.ceil((this.dataMax - this.dataMin) / 10)
          
            if (this.dataMax === 0) {
              positions = [0]
            } else if (this.dataMax !== null && this.dataMin !== null) {
                for (tick; tick  <= this.dataMax; tick += increment) {
                  positions.push(tick)
                }
            }
            return positions
          }
        },
        yAxis: {
          min: 0,
          max: 1,
          title: {
            text: 'Relevance'
          },
          labels: {
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [],
      },
      chartOptionsCallsByWeek: {
        chart: {
          height: 600,
          type: 'column',
          zoomType: 'x'
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
            formatter: function () {
                var tip = "<b>" + this.x + "</b>";
                tip += `<br/><b>${this.series.name}</b>: $${this.y.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>`;

                if (this.series.name == "Google PPC" || this.series.name == "Bing PPC") {
                  tip += `<b>Total</b>: $${(this.point.stackTotal/1).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
                }

                if (this.series.name == "Callrail calls In") {
                  tip = "<b>" + this.x + "</b>";
                  tip += `<br/><b>${this.series.name}</b>: ${this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>`;
                }
                
                return tip;
            },
        },
        xAxis: {
          categories: [],
          crosshair: true,
          gridLineWidth: 1,
          labels: {
          },
          type: 'datetime',
          tickPositioner: function () {
            let positions = [],        
                tick = Math.floor(this.dataMin),
                increment = Math.ceil((this.dataMax - this.dataMin) / 10)
          
            if (this.dataMax === 0) {
              positions = [0]
            } else if (this.dataMax !== null && this.dataMin !== null) {
                for (tick; tick  <= this.dataMax; tick += increment) {
                  positions.push(tick)
                }
            }
            return positions
          }
        },
        yAxis: {
          crosshair: true,
          min: 0,
          title: {
            text: null
          },
          labels: {
            formatter: function() {
                return this.value;
            }
          },
        },
        plotOptions: {
          column: {
            stacking: 'normal'
          },
        },
        series: [],
      },
      chartOptionsCallsByMonth: {
        chart: {
          height: 600,
          type: 'column',
          zoomType: 'x'
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
            formatter: function () {
                var tip = "<b>" + this.x + "</b>";
                tip += `<br/><b>${this.series.name}</b>: $${this.y.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>`;
                if (this.series.name == "Google PPC" || this.series.name == "Bing PPC") {
                  tip += `<b>Total</b>: $${(this.point.stackTotal/1).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
                }

                if (this.series.name == "Callrail calls In") {
                  tip = "<b>" + this.x + "</b>";
                  tip += `<br/><b>${this.series.name}</b>: ${this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>`;
                }

                return tip;
            },
        },
        xAxis: {
          categories: [],
          crosshair: true,
          gridLineWidth: 1,
          labels: {
          },
          type: 'datetime',
          tickPositioner: function () {
            let positions = [],        
                tick = Math.floor(this.dataMin),
                increment = Math.ceil((this.dataMax - this.dataMin) / 10)
          
            if (this.dataMax === 0) {
              positions = [0]
            } else if (this.dataMax !== null && this.dataMin !== null) {
                for (tick; tick  <= this.dataMax; tick += increment) {
                  positions.push(tick)
                }
            }
            return positions
          }
        },
        yAxis: {
          crosshair: true,
          min: 0,
          title: {
            text: null
          },
          labels: {
            formatter: function() {
                return this.value;
            }
          },
        },
        plotOptions: {
          column: {
            stacking: 'normal',
          },
        },
        series: [],
      },
      colors: [
        {color: '#6372c3', bg_color: 'rgba(99, 114, 195, 0.4)'},
        {color: '#f79e20', bg_color: 'rgb(247, 158, 32, 0.4)'},
        {color: '#82ddb8', bg_color: 'rgba(130, 221, 184, 0.4)'},
        {color: '#d87691', bg_color: 'rgba(216, 118, 145, 0.4)'}
      ]
    }
  },
  watch: {

  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    if (localStorage.getItem('fromCounterPage')) {
      let data = JSON.parse(localStorage.getItem('fromCounterPage'))
      this.dateStart = data.dateStart
      this.dateEnd = data.dateEnd
      this.defaultPeriod = data.defaultPeriod
      localStorage.removeItem('fromCounterPage')
    }

    axios
      .get('/username')
      .then(response => (this.userName = response.data))
      this.applyFilters()
  },
  methods: {
    getDates(dates){
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.applyFilters()
    },
    applyFilters() {
      this.loaded = true
      axios
          .get('/dashboard/activity/' + this.dateStart + '/' + this.dateEnd)
          .then(response => {
            this.data = response.data
            
            this.data.campaign_total_by_week_chart.datasets.map((e, i) => {
              this.chartOptionsCallsByWeek.series.splice(i, 1, {
                name: e.label,
                data: e.data,
                color: this.colors[i].bg_color,
                borderColor: this.colors[i].color,
                borderWidth: 2,
                stack: (e.label == 'Google PPC' || e.label == 'Bing PPC') ? '2' 
                                                                  : (e.label =='Sale') ? '1' : '3'
              })
            })
            this.chartOptionsCallsByWeek.xAxis.categories = this.data.campaign_total_by_week_chart.labels

            this.data.campaign_total_by_month_chart.datasets.map((e, i) => {
              this.chartOptionsCallsByMonth.series.splice(i, 1, {
                name: e.label,
                data: e.data,
                color: this.colors[i].bg_color,
                borderColor: this.colors[i].color,
                borderWidth: 2,
                stack: (e.label == 'Google PPC' || e.label == 'Bing PPC') ? '2' 
                                                                  : (e.label =='Sale') ? '1' : '3'
              })
            })
            this.chartOptionsCallsByMonth.xAxis.categories = this.data.campaign_total_by_month_chart.labels         

              this.data.integral_avg_graph_day.datasets.map((e, i) => {
                this.chartOptionsDay.series.splice(i, 1, {
                  name: e.label,
                  data: e.data,
                  color: this.colors[i].color,               
                })
              })
              this.chartOptionsDay.xAxis.categories = this.data.integral_avg_graph_day.labels

              this.data.integral_avg_graph_week.datasets.map((e, i) => {
                this.chartOptionsWeek.series.splice(i, 1, {
                  name: e.label,
                  data: e.data,
                  color: this.colors[i].color,               
                })
              })
            this.chartOptionsWeek.xAxis.categories = this.data.integral_avg_graph_week.labels                
          
            
            this.data.integral_avg_graph_month.datasets.map((e, i) => {
              this.chartOptionsMonth.series.splice(i, 1, {
                name: e.label,
                data: e.data,
                color: this.colors[i].color,               
              })
            })
            this.chartOptionsMonth.xAxis.categories = this.data.integral_avg_graph_month.labels       
          
          this.data.q3_by_day.datasets.map((e, i) => {
            this.chartOptionsRelevanceByDay.series.splice(i, 1, {
              name: e.label,
              data: e.data,
              color: e.backgroundColor               
            })
          })
          this.chartOptionsRelevanceByDay.xAxis.categories = this.data.q3_by_day.labels

          this.loaded = false
        })
    }
  }
}
</script>

<style scoped>
  .text-card {
    font-size: 30px;
    text-align: center;
  }
  .pa-2{
    min-height: 150px;
  }
</style>